const config = {
  apiHost: process.env.REACT_APP_API_HOST
};

export default config;
